import React, { Component } from 'react';
import { Column } from "primereact/column";
import { DataTable } from 'primereact/datatable';
import servicioObjetos from '../../servicio/ServicioObjetos';
import servicioHttp from '../../servicio/ServicioHttp';
import { InputText } from 'primereact/inputtext';
import { Calendar } from "primereact/calendar";
import { Growl } from 'primereact/growl';
import { Card } from 'primereact/card';
import { Paginator } from 'primereact/paginator';
import { Message } from "primereact/message";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from 'primereact/accordion';
import servicioFormatos from '../../servicio/ServicioFormatos';
import servicioIdiomaFecha from "../../servicio/ServicioIdiomaFecha";
import servicioCorreo from "../../servicio/ServicioCorreo";
import ServicioArchivos from "../../servicio/ServicioArchivos";
import envioC from '../Image/correo.png';
import Iconopdf from '../Image/pdf_icon.png';
import Iconoxml from '../Image/xml_icon.png';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";


export class RecibosNomina extends Component {

    constructor() {
        super();
        this.state = {
            errores: {},
            recibos: {},
            paginacion: { registrosPorPagina: 20, join: { "ttUsuario": "alias_ttUsuario" } },
            inicio: 0,
            objetoLike: {},
            checked: false,
            modalEnvioCorreos: false,
            listaEnvioCorreo: false,
            cfdis: [],
            check: false,
            erroresCorreo: {},
            enviocorreo: {}
        }

    }
    componentDidMount() {
        this.obtenerPagina();
    }
    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    reinicarConsultas = () => {
        let { paginacion } = this.state;
        paginacion['restriccionesDinamicas'] = [];
        this.setState({ objetoLike: {}, paginacion });
    }
    obtenerPagina() {
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp("consulta/recibos_nomina.json",
            paginacion).then((response) => {
                this.growl.show({
                    severity: response.data.error === false ?
                        "success" : "error", summary: "", detail: response.data.mensaje,
                });
                this.setState({ paginacion: response.data.objeto });
            }).catch((error) => {
                this.growl.show({
                    severity: "error", summary: "", detail: "Se generó un error no esperado, por favor inténtelo de nuevo",
                });
            });
    }
    buscarPorFecha = () => {
        let { paginacion, recibos } = this.state;
        try {
            if (servicioObjetos.esObjetoVacio(recibos.fechaPago))
                throw new Error("Campos requerido");
            console.log(recibos.fechaPago);
            let date = new Date(recibos.fechaPago);
            let primerDiasMes = new Date(date.getFullYear(), date.getMonth(), 1);
            let ultimoDiaMes = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            console.log(primerDiasMes);
            console.log(ultimoDiaMes);

            paginacion['numeroPagina'] = 0;
            paginacion['restriccionesDinamicas'] = [];
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "between", nombrePropiedad: "fechaPago",
                valorPropiedad: null, modoLike: null,
                fechaIncialBetween: servicioFormatos.formatearFechaString(primerDiasMes),
                fechaFinalBetween: servicioFormatos.formatearFechaString(ultimoDiaMes)
            });
            this.setState({ paginacion, inicio: 0 });
            this.obtenerPagina();
        } catch (e) {
            this.growl.show({ severity: "error", detail: e.message, life: 10000 });
        }
    }
    buscarPorCURP = () => {
        let { paginacion, recibos } = this.state;
        try {
            if (servicioObjetos.esObjetoVacio(recibos.curp))
                throw new Error("Campo requerido");

            paginacion['numeroPagina'] = 0;
            paginacion['restriccionesDinamicas'] = [];
            paginacion['restriccionesDinamicas'] = [{
                tipoRestriccion: "eq",
                nombrePropiedad: "curp", valorPropiedad: recibos.curp
            }]
            this.setState({ paginacion });
            this.obtenerPagina();
        } catch (e) {
            this.growl.show({ severity: "error", detail: e.message, life: 10000 });
        }
    }
    asignarValores = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }
    descargarPDF = (rowData, column) => {
        return <div className="p-grid" style={{ justifyContent: 'center' }}>
            <img src={Iconopdf} alt="" style={{ height: '40px', width: '40px', justifyContent: 'center' }}
                onClick={(e) => this.generaDescarga(column.rowData, 'pdf')} />
        </div>
    }
    generaDescarga = (objeto, tipo) => {
        ServicioArchivos.descargaArchivo('/documento/descarga_archivo.json?id=' + objeto.id + '&tipo=' + tipo, null, this);

    }
    descargarXML = (rowData, column) => {
        return <div className="p-grid" style={{ justifyContent: 'center' }}>
            <img src={Iconoxml} alt="" style={{ height: '40px', width: '40px', justifyContent: 'center' }}
                onClick={(e) => this.generaDescarga(column.rowData, 'xml')} />
        </div>
    }
    buscarPorUUID = () => {
        let { paginacion, recibos } = this.state;
        try {
            if (servicioObjetos.esObjetoVacio(recibos.uuid))
                throw new Error("Campo requerido");
            paginacion['numeroPagina'] = 0;
            paginacion['restriccionesDinamicas'] = [];
            paginacion['restriccionesDinamicas'] = [{
                tipoRestriccion: "eq",
                nombrePropiedad: "uuid", valorPropiedad: recibos.uuid
            }];
            this.setState({ paginacion });
            this.obtenerPagina();
        } catch (e) {
            this.growl.show({ severity: "error", detail: e.message, life: 10000 });
        }
    }
    enviarCorreos = () => {
        let { cfdis, enviocorreo, listaEnvioCorreo } = this.state;
        const resultadoValidacion = this.validarCorreo(enviocorreo.correo);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            cfdis.forEach(cfdi => {
                let correo = {};
                correo['correo'] = enviocorreo.correo;
                correo['uuid'] = cfdi.uuid;
                listaEnvioCorreo.push(correo);
            });
            servicioCorreo.enviarCorreo(listaEnvioCorreo).then(response => {
                this.growl.show({ life: 4000, severity: 'success', summary: '', detail: response.data.mensaje });
                this.cerrarModalEnviarCorreos();
            }).catch(error => {
                this.growl.show({ life: 4000, severity: 'error', summary: '', detail: error.response.data.mensaje });
            })


        }
    }
    columnaEnviarCorreos = (rowData, column) => {
        return <div className="p-grid" style={{ justifyContent: 'center' }}>

            <Checkbox color="primary" inputId={rowData.uuid} value={rowData} onChange={this.asignarCfdis.bind(this)} checked={this.state.cfdis.includes(rowData)} check={true}></Checkbox>

        </div>
    }
    asignarCfdis(e) {
        let { cfdis } = this.state;

        if (e.checked)
            cfdis.push(e.value);
        else
            cfdis.splice(cfdis.indexOf(e.value), 1);

        this.setState({ cfdis });
    }
    enviarCfdis = () => {
        let { cfdis } = this.state;
        if (cfdis.length === 0)
            return this.growl.show({ life: 3000, severity: 'error', summary: null, detail: "Selecciona al menos un comprobante" });
        this.setState({ modalEnvioCorreos: true, listaEnvioCorreo: [] });

    }

    validarCorreo = (correo) => {
        const errores = {};
        let regularCorreo = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
        if (!correo)
            errores.correo = "El campo es requerido";

        let correos = correo.split(',');
        correos.forEach(nuevoCorreo => {
            if (!regularCorreo.test(nuevoCorreo))
                errores.correo = "Correo o correos inválidos";
        })

        return errores;
    }
    formatoFechaPago = (rowData, column) => {
        return <p>{servicioFormatos.formatearFecha(rowData.fechaPago)}</p>
    }
    formatoFechaInicial = (rowData, column) => {
        return <p>{servicioFormatos.formatearFecha(rowData.fechaInicialPago)}</p>
    }
    formatoFechaFinal = (rowData, column) => {
        return <p>{servicioFormatos.formatearFecha(rowData.fechaFinalPago)}</p>
    }

    cerrarModalEnviarCorreos = () => {
        this.setState({ listaEnvioCorreos: [], enviocorreo: {}, erroresCorreo: {}, modalEnvioCorreos: false, cfdis: [] })
    }
    render() {
        let { errores, paginacion, recibos, inicio, erroresCorreo, enviocorreo } = this.state;

        const dialogFooter = (
            <div>
                <Button icon="pi pi-envelope" label="Enviar" onClick={this.enviarCorreos} />
                <Button icon="pi pi-times-circle" label="Cancelar"
                    className="p-button-danger" onClick={this.cerrarModalEnviarCorreos} />
            </div>
        );
        return (
            <div className="p-grid " >
                <Growl ref={(el) => (this.growl = el)} />


                <Card className="p-col-12 p-md-12">
                    <h1 style={{ textAlign: 'center', fontSize: '30px', fontWeight: 'bolder' }} > RECIBOS DE NÓMINA</h1>
                </Card>
                <Accordion onTabOpen={this.reinicarConsultas} onTabClose={this.reinicarConsultas} style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                    <AccordionTab header="Buscar por fecha de pago de cada mes" >
                        <div className="p-col-12 p-md-12" >
                            <label> Fecha inicial:    </label>
                            <Calendar name="recibos.fechaPago" value={recibos.fechaPago} onChange={(e) => { this.asignarValores(e, true) }} className={errores.fechaCreacion ? 'p-error' : ''}
                                view="month" dateFormat="yy-mm-dd" yearNavigator={true} yearRange="2018:2030" locale={servicioIdiomaFecha} />
                            {errores.fechaPago ? <Message severity="error" text={errores.fechaPago} /> : ""}
                            <Button icon="pi pi-search " label="Buscar Recibo" style={{ textAlign: 'rigth', marginLeft: '20px' }} onClick={this.buscarPorFecha} />
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Buscar por CURP">
                        <div className="p-col-12 p-md-12">
                            <label >Ingrese el CURP: </label>
                            <InputText id="1" maxLength="18" name='recibos.curp' value={recibos.curp}
                                onChange={(e) => { this.asignarValores(e, true) }} />
                            <Button icon="pi pi-search " label="Buscar Recibo" style={{ textAlign: 'rigth', marginLeft: '20px' }} onClick={this.buscarPorCURP} />

                        </div>
                    </AccordionTab>
                    <AccordionTab header="Buscar por folio fiscal">
                        <div className="p-col-12 p-md-12">
                            <label >Ingrese el folio fiscal: </label>
                            <InputText id="1" name="recibos.uuid" value={recibos.uuid}
                                onChange={(e) => { this.asignarValores(e, false) }} />
                            <Button icon="pi pi-search " label="Buscar Recibo" style={{ textAlign: 'rigth', marginLeft: '20px' }} onClick={this.buscarPorUUID} />
                        </div>
                    </AccordionTab>
                </Accordion>
                <Card className="p-col-12 p-md-12">
                    <div className="card card-w-title  p-fluid">
                        <DataTable value={paginacion.datos} layout={this.state.layout}
                            header="MIS RECIBOS" resizableColumns={true} autoLayout={true} >
                            <Column field="curp" header="Curp" sortable={true} style={{ width: '100px', fontSize: '13px', textAlign: 'center' }} />
                            <Column body={this.formatoFechaInicial} header="Fecha inicial pago" sortable={true} style={{ width: '100px', fontSize: '13px', textAlign: 'center' }} />
                            <Column body={this.formatoFechaFinal} header="Fecha final pago" sortable={true} style={{ width: '90px', fontSize: '13px', textAlign: 'center' }} />
                            <Column body={(e) => servicioFormatos.formatoEstadoCfdi(e.estado)} header="Estado" sortable={true} style={{ width: '70px', fontSize: '13px', textAlign: 'center' }} />
                            <Column body={(e) => servicioFormatos.formatoNomina(e.tipoNomina)} header="Tipo nomina" sortable={true} style={{ width: '80px', fontSize: '13px', textAlign: 'center' }} />
                            <Column field="uuid" header="Folio fiscal" sortable={true} style={{ width: '70px', fontSize: '13px', textAlign: 'center' }} />
                            <Column header="Fecha pago" body={this.formatoFechaPago} sortable={true} style={{ width: '70px', fontSize: '13px', textAlign: 'center' }} />
                            <Column header="Total" body={(e) => servicioFormatos.formatearModena(e.total)} sortable={true} style={{ width: '70px', fontSize: '13px', textAlign: 'center' }} />
                            <Column header="Descarga PDF" body={this.descargarPDF.bind(this)} sortable={true} style={{ width: '80px', fontSize: '13px', textAlign: 'center' }} />
                            <Column header="Descarga XML" body={this.descargarXML.bind(this)} sortable={true} style={{ width: '80px', fontSize: '13px', justifyContent: 'center' }} />
                            <Column header={<img src={envioC} alt="" onClick={this.enviarCfdis} style={{ height: '40px', width: '40px', justifyContent: 'center' }} />} body={this.columnaEnviarCorreos.bind(this)} sortable={true} style={{ width: '50px', fontSize: '13px', justifyContent: 'center' }} />
                        </DataTable>
                        <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                    </div>
                </Card>
                <Dialog header="Enviar mi comprobante" visible={this.state.modalEnvioCorreos}
                    modal={true} style={{ width: '60%' }} footer={dialogFooter}
                    onHide={this.cerrarModalEnviarCorreos}  >
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-4" style={{ marginTop: '14px' }}>
                            <label htmlFor="fechaFinal" >Ingresa el correo, si será más de un correo separalos por una ( , ) :</label>
                        </div>
                        <div className="p-col-12 p-md-8">
                            <InputText
                                id="enviocorreo" name="enviocorreo.correo"
                                className={erroresCorreo.correo ? 'p-error' : ''} value={enviocorreo.correo || ''}
                                onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                        </div>


                    </div>
                </Dialog>
            </div>
        );
    }


}